import RetailCollection from 'app/src/data/models/RetailCollection';
import PaymentTransaction from 'app/src/data/models/SaleLine';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class SaleLineCollection extends RetailCollection {
  get model() {
    return PaymentTransaction;
  }

  /**
   * Return the REST url for collection of payment service SaleLines
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/SaleLine.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.SaleLine is an array of the SaleLine structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    return response.SaleLine || [];
  }
}
